import type { Tournament } from '@/types/tournament.model';

/**
 * What the tournament does with its last day, which decides what a pair has to declare. With groups it
 * is the crossovers day and the earlier days hold the groups. A knockout-only bracket uses every day,
 * unless it shares a block with a groups tournament: then it stays on the last day, and that day
 * alone is enough.
 */
export type FinalDayRule =
  | 'crossovers'
  | 'knockoutEveryDay'
  | 'knockoutLastDayOnly';

export function finalDayRuleOf(
  tournament: Pick<Tournament, 'isKnockoutOnly' | 'knockoutUsesEveryDay'>,
): FinalDayRule {
  if (!tournament.isKnockoutOnly) return 'crossovers';
  // Absent (an older backend) reads as every day: asking for an earlier slot is the safe side.
  return tournament.knockoutUsesEveryDay === false
    ? 'knockoutLastDayOnly'
    : 'knockoutEveryDay';
}
